import React from 'react';
import {Button, Modal, ModalBody, ModalFooter} from 'reactstrap';
import './SubmitClaimModal.scss';

const SubmitClaimModal = ({onSubmit, onCancel, claimedItemsCount, sendEventData}) => {
    return (
        <Modal className='submit-claim-modal' isOpen>
            <ModalBody>
                <p>You have {claimedItemsCount} pending item(s)</p>
                <p>Are you ready to submit your claim?</p>
            </ModalBody>
            <ModalFooter>
                <Button color='success' size='sm' className='submit-claim-btn' onClick={() => {
                    sendEventData('submit_claim', {
                        name: 'Submit Claim',
                        category: 'Button click',
                        label: `Items count: ${claimedItemsCount}`,
                    });
                    onSubmit();
                    onCancel();
                }}>Submit Claim</Button>
                <Button color='info' size='sm' className='keep-browsing-btn' onClick={() => {
                    sendEventData('keep_browsing', {
                        name: 'Keep Browsing',
                        category: 'Button click',
                        label: `Items count: ${claimedItemsCount}`,
                    });
                    onCancel();
                }}>Keep Browsing</Button>
            </ModalFooter>
        </Modal>
    );
};

export default SubmitClaimModal;


// WEBPACK FOOTER //
// ./src/containers/embeddable/utils/SubmitClaimModal.js